import React, { useEffect, useState } from 'react';
import PageContainer from '../../../components/PageContainer';
import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, Grid, IconButton } from '@mui/material';
import { Add, BusinessOutlined, DeleteForever, DeleteForeverOutlined, DeleteOutlined, EditOutlined } from '@mui/icons-material';
import { Link, useHistory } from 'react-router-dom';
import * as Yup from 'yup';
import { DataGrid } from '@mui/x-data-grid';
import moment from 'moment';
import { addOrUpdateInstitutionType, deleteInstitutionType, getInstitutionTypes } from '../../../redux/api/institution';
import { useSnackbar } from 'notistack';
import { Form, Formik } from 'formik';
import TextInput from '../../../components/common/TextInput';
const InstitutionTypes = () => {
    const [processing, setProcessing] = useState(false);
    const defaultType = {
        isActive: true,
        status: '',
        institutionTypeId: '',
        name: '',
        code: '',
        description: '',
    };
    const [selectedType, setSelectedType] = useState({});
    const [openModal, setOpenModal] = useState(false);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const [records, setRecords] = useState([]);

    const columns = [
        {
            field: 'sn',
            headerName: 'S/N',
            width: 80,
            sortable: false,
            renderCell: (params) => {
                return <p style={{ margin: 'auto' }}>{(params?.api?.getRowIndex(params?.row?.institutionTypeId) || 0) + 1}</p>;
            },
        },
        {
            field: 'action',
            headerName: 'Action',
            width: 100,
            sortable: false,
            renderCell: (params) => {
                return (
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '100%',
                        }}
                    >
                        <IconButton
                            size="small"
                            color="primary"
                            variant="outlined"
                            title="Edit"
                            onClick={() => {
                                setSelectedType(params?.row);
                                setOpenModal(true);
                            }}
                        >
                            <EditOutlined />
                        </IconButton>

                        <IconButton
                            size="small"
                            color="error"
                            variant="outlined"
                            title="Edit"
                            onClick={() => {
                                setSelectedType(params?.row);
                                setOpenDeleteModal(true);
                            }}
                        >
                            <DeleteOutlined />
                        </IconButton>
                    </div>
                );
            },
        },
        { field: 'code', headerName: 'Code', width: 200 },
        { field: 'name', headerName: 'Name', width: 300 },

        { field: 'description', headerName: 'Description', width: 350 },
        {
            field: 'createdDate',
            headerName: 'Creation Date',
            width: 200,
            valueGetter: (params) => (params?.row?.createdOn ? moment(params?.row?.createdOn).format('DD/MM/YY hh:mm') : ''),
        },
        { field: 'createdBy', headerName: 'Creation By', width: 200 },
    ];

    const handleSubmit = async (values) => {
        try {
            await addOrUpdateInstitutionType(values);
            setOpenModal(false);
            setSelectedType({});
            enqueueSnackbar(`Institution Type ${Boolean(values?.institutionTypeId) ? 'updated' : 'created'} successfully`);
            init();
        } catch (err) {
            enqueueSnackbar(err?.message || 'An error occurred', {
                variant: 'error',
            });
        }
    };

    const handleDeletion = async (values) => {
        try {
            await deleteInstitutionType(values.institutionTypeId);
            setOpenDeleteModal(false);
            setSelectedType({});
            enqueueSnackbar(`Institution Type deleted successfully`);

            init();
        } catch (err) {
            enqueueSnackbar(err?.message || 'An error occurred', {
                variant: 'error',
            });
        }
    };

    const init = async () => {
        try {
            setProcessing(true);
            const res = await getInstitutionTypes();
            setRecords(res || []);
        } catch (err) {
            enqueueSnackbar(err?.message || 'An error occurred', {
                variant: 'error',
            });
        } finally {
            setProcessing(false);
        }
    };

    useEffect(() => {
        init();
    }, []);

    return (
        <PageContainer
            pageTitle="All Institutions Types"
            tagline="Manage all institutions"
            processing={processing}
            buttonComponent={
                <>
                    <Button
                        onClick={() => {
                            setSelectedType({});
                            setOpenModal(true);
                        }}
                        startIcon={<BusinessOutlined />}
                        style={{ margin: '0 .5rem' }}
                        variant="contained"
                    >
                        Create Institution Type
                    </Button>
                </>
            }
        >
            <Box>
                <div className="paper" style={{ height: 550, width: '100%', textAlign: 'center' }}>
                    <DataGrid
                        className={'center-first-column'}
                        rows={records}
                        getRowId={(row) => row.institutionTypeId}
                        columns={columns}
                        pageSize={10}
                        rowsPerPageOptions={[10]}
                        checkboxSelection={false}
                        disableSelectionOnClick
                        style={{ fontSize: '12px' }}
                    />
                </div>
            </Box>

            <Dialog open={openModal}>
                <h5 className="text-center mt-2">{Boolean(selectedType?.institutionTypeId) ? 'Edit' : 'Create'} Institution Type</h5>
                <Formik
                    initialValues={{ ...selectedType }}
                    enableReinitialize
                    onSubmit={handleSubmit}
                    validationSchema={Yup.object().shape({
                        name: Yup.string().required('Institution Type Name is required.'),
                        code: Yup.string().required('Institution Type Code is required.'),
                    })}
                >
                    {({ isSubmitting }) => (
                        <Form>
                            <DialogContent>
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        <TextInput id="code" required label="Institution Type Code" />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextInput id="name" required label="Institution Type Name" />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextInput id="description" multiline minRows={2} label="Institution Type Description" />
                                    </Grid>

                                    <Grid item xs={12} container alignItems={'center'} justifyContent={'flex-end'} gap={'10px'}>
                                        <Button
                                            color="secondary"
                                            variant="contained"
                                            onClick={() => {
                                                setOpenModal(false);
                                                setSelectedType({});
                                            }}
                                        >
                                            Cancel
                                        </Button>
                                        <Button type="submit" disabled={isSubmitting} startIcon={<Add />} variant="contained">
                                            {isSubmitting ? <CircularProgress size={15} color="inherit" /> : selectedType?.institutionTypeId ? 'Edit Type' : 'Add Type'}
                                        </Button>
                                    </Grid>
                                </Grid>
                            </DialogContent>
                        </Form>
                    )}
                </Formik>
            </Dialog>

            <Dialog open={openDeleteModal} maxWidth="xs" fullWidth>
                <DialogContent>
                    <Formik initialValues={selectedType} enableReinitialize onSubmit={handleDeletion}>
                        {({ isSubmitting }) => (
                            <Form>
                                <h3 className="f-16 mb-0">Delete Institution Type</h3>
                                <p>
                                    Kindly confirm you want to delete this institution type: <b>{selectedType?.name}</b>
                                </p>
                                <Grid container justifyContent={'flex-end'} gap={'10px'} mt={3}>
                                    <Button
                                        color="secondary"
                                        variant="contained"
                                        onClick={() => {
                                            setOpenDeleteModal(false);
                                            setSelectedType({});
                                        }}
                                        disabled={isSubmitting}
                                    >
                                        Cancel
                                    </Button>
                                    <Button disabled={isSubmitting} color="error" type="submit" variant="contained">
                                        {isSubmitting ? <CircularProgress size={15} /> : 'Confirm'}
                                    </Button>
                                </Grid>
                            </Form>
                        )}
                    </Formik>
                </DialogContent>
            </Dialog>
        </PageContainer>
    );
};

export default InstitutionTypes;
